import { memo, useMemo } from "react";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { formatLocalTime, formatNumber, statusColorVar, throughputUnit } from "../../lib/format";
function TooltipBox({ active, payload }) {
    if (!active || !payload?.length)
        return null;
    const row = payload[0].payload;
    return (<div className="rounded-md border border-border bg-bg-elevated px-2 py-1 text-[11px] shadow-node">
      <div className="text-fg-subtle">{row.label}</div>
      <div className="tabular font-semibold text-fg">{formatNumber(row.v, row.v >= 100 ? 0 : 1)}</div>
    </div>);
}
/** 최근 60점 처리량 Area 차트. 고정 높이·애니메이션 off (2초마다 갱신되므로). */
export const ThroughputChart = memo(function ThroughputChart({ history, nodeType, status = "healthy", height = 120, className, }) {
    const rows = useMemo(() => history.map((h) => ({ t: h.t, label: formatLocalTime(h.t), v: Number.isFinite(h.v) ? h.v : 0 })), [history]);
    const color = statusColorVar(status === "offline" ? "offline" : status);
    const unit = throughputUnit(nodeType);
    const gradId = `tp-grad-${status}`;
    if (rows.length < 2) {
        return (<div className={className} style={{ height }} role="img" aria-label="처리량 추이: 데이터 수집 중">
        <div className="flex h-full items-center justify-center rounded-lg border border-dashed border-border text-[11px] text-fg-subtle">
          처리량 추이 수집 중… ({rows.length}/60)
        </div>
      </div>);
    }
    return (<div className={className} style={{ height }} role="img" aria-label={`최근 처리량 추이 (${unit}), ${rows.length}점`}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={rows} margin={{ top: 6, right: 4, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.45}/>
              <stop offset="100%" stopColor={color} stopOpacity={0.02}/>
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#1c2747" strokeDasharray="2 4" vertical={false}/>
          <XAxis dataKey="label" tick={{ fill: "#6b7699", fontSize: 10 }} tickLine={false} axisLine={false} minTickGap={40} interval="preserveStartEnd"/>
          <YAxis width={34} tick={{ fill: "#6b7699", fontSize: 10 }} tickLine={false} axisLine={false} allowDecimals={false} domain={[0, "auto"]}/>
          <Tooltip content={<TooltipBox />} cursor={{ stroke: "#33448a", strokeWidth: 1 }} isAnimationActive={false}/>
          <Area type="monotone" dataKey="v" stroke={color} strokeWidth={1.5} fill={`url(#${gradId})`} isAnimationActive={false} dot={false} activeDot={{ r: 3, strokeWidth: 0 }}/>
        </AreaChart>
      </ResponsiveContainer>
    </div>);
});
